import React from 'react';
import { ActionText, TextLink } from '@dsg-tech/homefield-react';
import { StoreDetails } from 'types';
import { assignChainName } from 'utility/utility';
import { FulfillmentButtonState, SkuDetails } from '../../types';
import FulfillmentButtonLowStockMessage from './components/FulfillmentButtonLowStockMessage';

type Props = {
  shipButtonState: FulfillmentButtonState;
  storeButtonState: FulfillmentButtonState;
  sddButtonState: FulfillmentButtonState;
  activeOption: string;
  selectedStore: StoreDetails | null;
  skuList: string[];
  sku: SkuDetails;
};

const FulfillmentMessaging = ({
  shipButtonState,
  storeButtonState,
  sddButtonState,
  activeOption,
  selectedStore,
  skuList,
  sku,
}: Props) => {
  const handleOpenStoreModalService = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.headerFunctions.storeSelection({
      ...(skuList && { skusArr: skuList }),
      ...(sku?.partNumber && { selectedSkuVal: sku.partNumber }),
    });
  };

  switch (activeOption) {
    case 'SHIP':
      return (
        <div
          className="FulfillmentMessaging hmf-display-flex hmf-flex-column hmf-mt-xs"
          id="FulfillmentMessaging-ship">
          <FulfillmentButtonLowStockMessage buttonState={shipButtonState} />
        </div>
      );
    case 'BOPIS':
    case 'BOPL':
      return (
        <div
          className="FulfillmentMessaging hmf-display-flex hmf-flex-column"
          id="FulfillmentMessaging-store">
          {storeButtonState.selectedMessaging.message && (
            <p className="hmf-m-0 hmf-body-l label-base hmf-mb-xxs">
              {storeButtonState.selectedMessaging.message}
            </p>
          )}

          {activeOption === 'BOPL' && (
            <p className="FulfillmentMessaging-boplMsg label-base hmf-m-0 hmf-body-l hmf-mb-xxs">
              Available for Pickup in 5-10 business days.
            </p>
          )}

          {selectedStore && (
            <div className="hmf-display-flex hmf-flex-row">
              <p className="hmf-m-0 hmf-body-bold-l">
                {`${assignChainName(selectedStore.chain)} - `}
                <span className="hmf-body-bold-l hmf-text-transform-capitalize">{`${selectedStore.name.toLowerCase()}`}</span>
              </p>
              <ActionText
                variant="primary"
                size="medium"
                className="hmf-ml-xxs"
                onClick={handleOpenStoreModalService}>
                Change Store
              </ActionText>
            </div>
          )}
          <FulfillmentButtonLowStockMessage buttonState={storeButtonState} classes="hmf-mt-xxs" />
          {sku &&
            selectedStore &&
            // Only show nearby stores messaging if both sku and selectedStore exist
            (storeButtonState.selectedMessaging.nearbyStores ? (
              <p className="hmf-m-0 hmf-body-m label-base hmf-mt-xxs">
                {storeButtonState.valid ? 'Also available' : 'Available'} at{' '}
                <span className="hmf-body-bold-m label-base">
                  {storeButtonState.selectedMessaging.nearbyStores}
                </span>{' '}
                nearby stores.
              </p>
            ) : (
              <p className="hmf-m-0  label-base hmf-body-m hmf-mt-xxs">
                Not available at any nearby stores within 100 miles.
              </p>
            ))}
        </div>
      );
    case 'SDD':
      return (
        <div
          className="FulfillmentMessaging hmf-display-flex hmf-flex-column hmf-mt-xs"
          id="FulfillmentMessaging-sdd">
          {sddButtonState.selectedMessaging.message && (
            <p className="hmf-m-0 label-base hmf-body-l">
              {sddButtonState.selectedMessaging.message}
            </p>
          )}
          <FulfillmentButtonLowStockMessage buttonState={sddButtonState} classes="hmf-my-xxs" />
          {sddButtonState.valid && (
            <>
              <p className="hmf-m-0 label-base hmf-body-l">
                Order by 4pm, get it today! Order after 4pm, get it next day.
              </p>
              <p className="hmf-m-0 hmf-body-l hmf-mt-xxs">
                Delivered By DoorDash for $9.99!{' '}
                <TextLink variant="primary" href="/s/same-day-delivery" size="medium">
                  Details
                </TextLink>
              </p>
            </>
          )}
        </div>
      );
    default:
      return null;
  }
};

export default FulfillmentMessaging;
